export default {
  'search': {
    'placeholder': '区块高度、交易哈希、账户地址',
    'errorTips': '目标区块高度/交易hash/账户地址错误',
    'inputPlaceholder': '请输入区块高度、交易hash或账户地址',
    'errWarning': '区块高度/交易hash/账户地址错误'
  },
  'common': {
    'time': {
      's': '秒前',
      'm': '分钟前',
      'h': '小时前'
    },
    'nav': {
      'index': '首页',
      'txList': '交易列表',
      'token': '资产',
      'nft': 'NFTs',
      'more': '更多的',
      'export': 'CSV 导出'
    },
    'txType': {
      'payCoin': '转移Gas',
      'invokeContract': '调用合约',
      'createContract': '创建合约',
      'issueAsset': '发行Token',
      'createAccount': '创建账户',
      'unknown': '账户',
      'payAsset': '转移Token'
    },
    'txStatus': {
      'success': '成功',
      'fail': '失败'
    },
    'errorMsg': {
      'dealing': '交易正在处理',
      'noBalance': '余额不足',
      'noActive': '激活目标账户费用不足',
      'unknownError': '未知错误'
    },
    'accType': {
      'normal': '普通账户',
      'unite': '联名账户',
      'contract': '合约账户'
    },
    'tabelName': {
      'time': '时间',
      'age': '年龄',
      'block': '所在区块',
      'txtype': '交易类型',
      'fromAddress': '源账户',
      'toAddres': '目的账户',
      'amount': '数量',
      'hash': '交易哈希',
      'status': '状态'
    },
    'btn': {
      'json': '原始数据',
      'formate': '格式化',
      'unFormate': '去格式化',
      'switchTo': '切换原文',
      'switchBack': '切换密文',
      'testBtn': '测试网入口',
      'mainBtn': '主网入口',
      'showAll': '全部展开',
      'showLess': '收起'
    },
    'nomace': '笔',
    'hashError': '目标交易hash不存在',
    'accountError': '目标账户地址错误',
    'blockError': '目标区块不存在',
    'tokenError': '目标资产不存在',
    'tableNoData': '暂无数据',
    'tableLoading': '数据加载中...',
    'webkitWarn': '温馨提示：为了更好的呈现用户体验，推荐您使用Chrome或Safari浏览器浏览本网站'
  },
  'index': {
    'totalData': {
      'title': '概览',
      'node': '实时节点数',
      'seq': '区块高度',
      'intervals': '间隔时间',
      'averageTime': '区块平均生成时间',
      'price': 'BU价格',
      'lastBlock': '最新区块',
      'txNum': '总交易数',
      'accountNum': '总账户数',
      'days': '运行天数',
      'day': '天',
      'chartsTitle': '双周BU交易数',
      'chartsTips': '交易数',
      'more': '更多'
    },
    'block': {
      'title': '区块',
      'secTitle': '（最新生成）',
      'label': {
        'time': '时间',
        'age': '年龄',
        'height': '高度',
        'size': '大小（Byte）',
        'reward': '块收益',
        'hash': '块哈希'
      }
    },
    'tx': {
      'title': '交易',
      'secTitle': '（最新生成）',
      'label': {
        'time': '时间',
        'age': '年龄',
        'block': '所在区块',
        'txType': '交易类型',
        'fromAddress': '源账户',
        'toAddress': '目的账户',
        'amount': '数量',
        'hash': '交易哈希',
        'status': '状态'
      }
    }
  },
  'account': {
    'baseInfo': {
      'title': '账户',
      'itemName': {
        'balance': 'Gas数量',
        'accType': '账户类型',
        'siners': '共管成员',
        'thresholds': '门限',
        'contract': '合约代码'
      }
    },
    'asset': {
      'listName': 'ZTP10资产列表',
      'assetName': '资产ID',
      'amount': '数量',
      'address': '资方账户地址'
    },
    'asset20': {
      'listName': 'ZTP20资产列表',
      'assetCode': '资产ID',
      'assetName': '资产名称',
      'amount': '数量',
      'contract': '资产合约'
    },
    'asset721': {
      'listName': 'ZTP721资产列表'
    },
    'asset1155': {
      'listName': 'ZTP1155资产列表'
    },
    'lastTx': {
      'moreLink': '更多交易',
      'listName': '最近5笔交易'
    },
    'accountTxList': {
      'title': '交易：账户'
    }
  },
  'block': {
    'baseInfo': {
      'title': '区块',
      'itemName': {
        'blockReward': '区块奖励',
        'txCount': '交易数',
        'seq': '区块高度',
        'ledgerSize': '区块大小',
        'version': '区块版本',
        'time': '区块生成时间',
        'hash': '区块哈希',
        'previousHash': '上一区块哈希',
        'accountTreeHash': '账户树哈希',
        'consensusValueHash': '共识信息哈希',
        'validatorsHash': '共识节点哈希'
      },
      'prevBlockBtn': '前一个区块',
      'nextBlockBtn': '后一个区块'
    },
    'blockTx': {
      'title': '包含的交易'
    }
  },
  'tx': {
    'list': {
      'listTitle': '交易列表'
    },
    'baseInfo': {
      'title': '交易哈希',
      'itemName': {
        'time': '时间',
        'age': '年龄',
        'ledgerSeq': '区块高度',
        'txType': '交易状态',
        'fee': '交易费用',
        'sourceAddress': '发起人账户地址',
        'signatureStr': '签名者'
      }
    },
    'operate': {
      'title': '操作',
      'secTitle': '（操作指创建账户、转账、调用合约、发行资产等）',
      'payCoin': {
        'name': '转移Gas',
        'itemName': {
          'fromAddress': '源账户地址',
          'toAddress': '目的账户地址',
          'amount': 'Gas数量'
        }
      },
      'payAsset': {
        'name': '转移token',
        'itemName': {
          'fromAddress': '源账户地址',
          'toAddress': '目的账户地址',
          'assetCode': '资产ID',
          'amount': '数量'
        }
      },
      'createAccount': {
        'name': '创建账户',
        'itemName': {
          'destAddress': '账户地址',
          'initBalance': '初始BU数量',
          'accType': '账户类型',
          'signers': '共管成员',
          'thresholds': '门限'
        }
      },
      'createContract': {
        'name': '创建合约',
        'itemName': {
          'destAddress': '合约地址',
          'initBalance': '初始Gas数量',
          'contract': '合约script'
        }
      },
      'issueAsset': {
        'name': '发行token',
        'itemName': {
          'assetIssuer': '资方账户地址',
          'assetCode': '资产ID',
          'amount': '发行数量'
        }
      },
      'invokeContract': {
        'name': '调用合约',
        'itemName': {
          'fromAddress': '合约执行人账户',
          'toAddress': '合约地址'
        }
      }
    }
  },
  'token': {
    'tokenPlaceholder': '请输入资产名',
    'overFlow': '告警: 该项目方已超发',
    'list': {
      'title': '资产列表',
      'title1': '资产合约列表',
      'tableTitle': 'Tokens',
      'assetCode': '序号',
      'tokenType': '类型',
      'ATPLimited': 'ZTP 固定型',
      'ATPIncremented': 'ZTP 增发型',
      'ATPUnlimited': 'ZTP 无限型',
      'CTPFixed': 'CTP 固定型',
      'totalSupply': '发行总量',
      'contractAddress': '合约地址',
      'issueAddress': '发行方地址',
      'assetType': '资产类型',
      'assetContractType': '资产合约类型',
      'decimals': '精度',
      'holderCount': '拥有资产地址数',
      'txCount': '交易笔数',
      'operation': '可用操作',
      'detail': '详情',
      'nolimit': '无限型',
      'ztpType': '协议类型',
      'tokenName': 'Token名称'
    },
    'detail': {
      'title': '资产',
      'tokenDetailTitle': 'Token详情',
      'profileSummary': 'Profile Summary',
      'overview': 'Overview',
      'tran': 'Transactions',
      'tabs': {
        'transaction': '交易',
        'holder': '持有者'
      },
      'txList': {
        'title': '交易列表',
        'time': '时间',
        'block': '所在区块',
        'type': '交易类型',
        'sourceAccount': '源账户',
        'destAccount': '目标地址',
        'amount': '数量',
        'hash': '交易哈希',
        'status': '状态'
      },
      'tranList': {
        'time': '时间',
        'age': '年龄',
        'block': '所在区块',
        'type': '类型',
        'from': '源账户',
        'to': '目标地址',
        'value': '数量',
        'hash': '交易哈希',
        'status': '状态'
      },
      'overviewDetail': {
        'tokenName': 'Token名称',
        'totalSupply': '发行量',
        'totalSupplyTip': '该Token在区块链网络发行总数',
        'issuingTime': '发行日期',
        'issuingTimeTip': '该Token的发行日期',
        'issuingAddress': '发行者',
        'issuingAddressTip': 'Token的发行者区块链地址',
        'holders': '持有者',
        'holdersTip': '持有该Token的账户数',
        'contractAddress': '发行合约',
        'contractAddressTip': '发行该Token的智能合约',
        'officialWebsite': '官网',
        'officialWebsiteTip': '该项目的官方网站',
        'decimals': '精度',
        'decimalsTip': '该Token支持最大小数位',
        'tokenProtocols': 'Token协议',
        'tokenProtocolsTip': '该Token的所属Token协议'
      },
      'pubRecord': {
        'title': '发行记录',
        'amount': '数量',
        'txHash': '交易哈希',
        'time': '发行时间'
      },
      'holderAddr': {
        'title': '持有资产地址列表',
        'address': '账户地址',
        'balance': '资产持有量',
        'percent': '占总发行量的比例'
      }
    },
    'tokenId': {
      'ownAddress': '所有人地址',
      'transferNum': '转移次数',
      'txDetail': '交易详情'
    }
  },
  'nfts': {
    'detail': {
      'baseInfo': {
        'title': '数字藏品 详情'
      },
      'overview': {
        'title': '概述',
        'property': {
          'creator': '铸造者',
          'creatorTip': 'NFT的铸造者',
          'contractAddress': '合约地址',
          'contractAddressTip': '铸造该NFT的智能合约',
          'issuingTime': '铸造时间',
          'issuingTimeTip': '铸造该NFT智能合约的时间',
          'holders': '持有者人数',
          'holdersTip': '持有该智能合约下的NFT账户数',
          'officialWebsite': '官网',
          'officialWebsiteTip': '该智能合约的官网地址',
          'tokenProtocols': 'ZTP协议',
          'tokenProtocolsTip': '该Token的所属Token协议'
        }
      },
      'optTabs': {
        'title': {
          'txs': 'Transactions',
          'inventory': 'Inventory',
          'contactCode': 'Contact code'
        }
      }
    },
    'tokenId': {
      'baseInfo': {
        'title': 'NFT 概述'
      },
      'holders': {
        'tabs': {
          'title': '持有者',
          'table': {
            'col': {
              'holder': '持有人',
              'quantity': 'Quantity'
            }
          }
        }
      }
    }
  },
  'more': {
    'export': {
      'title': '下载数据（CSV 导出)',
      'input': {
        'type': '选择导出类型',
        'address': '地址',
        'accAddress': '账户地址',
        'contract': '合约地址',
        'token': '代币合约地址',
        'accAddressTokenId': '账户地址/代币ID',
        'option': '选择下载选项',
        'date': '日期',
        'block': '区块编号',
        'startDate': '开始日期',
        'endDate': '结束日期',
        'download': '下载',
        'reset': '重置'
      },
      'info': {
        'desc': '您所请求的信息可以从此页面下载。在继续之前，请通过完成下面的验证码来验证您不是机器人',
        'limit': '将导出所选范围内最早的 5,000 条记录'
      }
    }
  }
}
